import OauthTokenValidator from "./OauthTokenValidator";

export default OauthTokenValidator;
